import { type CreateErrorOptions, type ValidationError, object, string } from "yup";
import { isUSA } from "../../../../common/utils/is_usa";
import {
  addressUsZipRegEx,
  alphanumericError,
  alphaNumericRegex,
  usZipSyntaxError,
} from "../../../SharedAddressInput/constants";
import { getNameFromCountry } from "../../mappers";

export const defaultBankAddress = {
  country: "",
  line1: "",
  line2: "",
  locality: "",
  postalCode: "",
  region: "",
};

export enum BankAddressInputFields {
  Country = "country",
  Line1 = "line1",
  Line2 = "line2",
  Locality = "locality",
  PostalCode = "postalCode",
  Region = "region",
}

export const validatePostalCode = ({
  postalCodePath,
  postalCodeValue,
  country,
  createErrorCb,
}: {
  postalCodePath?: string;
  postalCodeValue?: string;
  country?: string;
  createErrorCb: (params?: CreateErrorOptions | undefined) => ValidationError;
}) => {
  if (country && postalCodeValue) {
    if (country && isUSA(getNameFromCountry(country))) {
      if (!addressUsZipRegEx.test(postalCodeValue)) {
        return createErrorCb({ path: postalCodePath, message: usZipSyntaxError });
      }
    } else if (country && !alphaNumericRegex.test(postalCodeValue)) {
      return createErrorCb({ path: postalCodePath, message: alphanumericError });
    }
    return true;
  }
  return true;
};

export const BankAddressSchemaGenerator = ({
  countryFieldPath = "country",
}: {
  countryFieldPath?: string;
} = {}) =>
  object().shape({
    [BankAddressInputFields.Line1]: string(),
    [BankAddressInputFields.Line2]: string().nullable(),
    [BankAddressInputFields.Locality]: string(),
    [BankAddressInputFields.PostalCode]: string().test(
      "postal-code-validation",
      "Invalid Postal Code",
      (value, context) => {
        const { path, createError } = context;
        // Access the bankCountry from the grandParent object
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const bankCountry = context.from?.[1]?.value?.[countryFieldPath];
        return validatePostalCode({
          postalCodePath: path,
          postalCodeValue: value,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          country: bankCountry,
          createErrorCb: createError,
        });
      },
    ),
    [BankAddressInputFields.Region]: string(),
  });
